//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tooltip from '@/mixins/tooltip';
import DpDropdown from '../dropdown/Dropdown.vue';
import DpDropdownItem from '../dropdown/DropdownItem.vue';
import DpIndicator from '../notification/Indicator.vue';
import DpButton from './Button.vue';

export default {
  name: 'DpButtonWithOptions',
  components: {
    DpIndicator,
    DpButton,
    DpDropdown,
    DpDropdownItem,
  },
  mixins: [Tooltip],
  inheritAttrs: false,
  props: {
    // @TODO review which ones are needed
    // Button with options props
    options: { type: Array, default: () => [] },
    // Standard button props
    href: { type: String, default: '' },
    to: { type: Object, default: () => null },
    type: { type: String, default: 'custom' },
    text: { type: String, default: '', required: false },
    fullWidth: { type: Boolean, default: false },
    overrideBackgroundColour: { type: String, default: null },
    overrideTextColour: { type: String, default: null },
    block: { type: Boolean, default: false },
    action: { type: Function, require: false, default: undefined },
    size: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    externalLink: { type: Boolean, default: false },
    icon: { type: String, default: null },
    loading: { type: Boolean, default: false },
    loadingText: { type: String, default: null },
    submit: { type: Boolean, default: false },
    iconRotation: { type: Number, default: null },
    indicator: { type: String, default: null },
    iconSize: { type: Number, default: null },
  },
  data() {
    return {
      dropdownVisible: false,
    };
  },
  computed: {
    boundProps() {
      const passedProps = ['type', 'size', 'loading', 'disabled', 'icon'];
      const bound = {};
      passedProps.forEach((k) => {
        if (this[k] !== null) {
          bound[k] = this[k];
        }
      });
      return bound;
    },
    toggleProps() {
      return {
        ...this.boundProps,
        icon: 'bold-arrow-down',
        loading: false,
        disabled: this.boundProps.loading ? true : this.boundProps.disabled,
      };
    },
  },
  methods: {
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },
    closeDropdown() {
      this.dropdownVisible = false;
    },
    clickButton() {
      this.$emit('click');
    },
    clickOption(option) {
      if (option.emit) {
        this.$emit(option.emit);
        return;
      }
      this.$emit('click-option', option);
    },
  },
};
